import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { GrooveSurfaceDirective } from '@groove/angular';
import { RouteUiDataService } from '../../route-ui-data';
import { RELATED_TILES } from './related-tiles.catalog';

@Component({
  selector: 'app-page-explore',
  imports: [RouterLink, GrooveSurfaceDirective],
  templateUrl: './page-explore.component.html',
  styleUrl: './page-explore.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageExploreComponent {
  private readonly uiData = inject(RouteUiDataService);

  protected readonly tiles = computed(() =>
    this.uiData.related().map((key) => RELATED_TILES[key]),
  );

  protected readonly hasTiles = computed(() => this.tiles().length > 0);
}
